import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import config from '../../config'
import * as searchActions from 'redux/modules/search'
import {
  Link,
  LinkIcon,
  Grade,
  TargetDateLinks
} from '../../components'
import Styles from './TargetDateGrid.css'


@CSSModules(Styles, {allowMultiple:true})
class TargetDateGridItem extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    gradeField: PropTypes.string.isRequired,
    funds: PropTypes.array
  }

  constructor(props){
    super(props)

    const { fund, gradeField } = props

    const url = this.makeUrl(fund)
    const charGrade = fund[gradeField].toString()
    this.state = {
      fund,
      gradeField,
      url,
      charGrade
    }
  }

  componentWillMount() {
  }

  //
  makeUrl = (fund) => {
    const sName = format.sanitize(fund.fund_legal_name)
    const sTicker = fund.ticker || 'N'
    return config.routes.fund + '/' +
      sName + '/' +
      sTicker + '/' + config.profilePath + '/' +
      fund.fund_id + '/' +
      fund.investment_vehicle_id
  }
  //
  render() {
    const { fund, gradeField, url, charGrade  } = this.state
    //
    return <Row>
      <Col xs={12} sm={1}/> 
      <Col styleName='companies-box-wrap' xs={12} sm={10}>
        <div styleName='companies-box'>
          <div styleName='box-title-wrap'>
            <Link
              to={url}
              styleName='companies-link'
              title={fund.strategy_name + ' 2050 | ' + config.app.title}
            >      
              <div styleName='box-title'>
                <b>{ fund.strategy_name }</b>
                {
                  fund.sustainable_investment ?
                    (
                      <span styleName='leaf'>
                        <LinkIcon faclass='fa-leaf' />
                      </span>
                    ) :
                    null
                }
              </div>
            </Link>

            <TargetDateLinks funds={this.props.funds} strategyName={fund.strategy_name}/>

            { /* <div styleName='box-subtitle'>
              <span>{ fund.fund_legal_name }</span>
              { fund.ticker && fund.ticker !== 'N' ?
                  <span>&nbsp;({ fund.ticker })</span> :
                  null
              }
            </div> */ }
          </div>

          <div styleName='box-grade-wrap'>
            <Link
              to={url}
              styleName='companies-link'
              title={fund.strategy_name + ' | ' + config.app.title}
            >  
              <Grade grade={fund[gradeField]} block />
            </Link>
          </div>
        </div>
      </Col>
      <Col xs={12} sm={1}/> 
    </Row>
  }
}

@connect(
  state => ({
    result: state.fundsByStrategy.result,
    searching: state.fundsByStrategy.loading,
    searched: state.fundsByStrategy.loaded,
    error: state.fundsByStrategy.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateGrid extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props){
    super(props)
    this.state = {
      targetDateSeriesList: [].concat(config.targetDateSeries),
      fundsByStrategy: {}
    }
  }
  //
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    // unique strategy names of each target date series
    const strategy_names = [...new Set(config.targetDateSeries.map((x) => x.strategy_name))]
    // call API
    this.props.getFundsByStrategy(strategy_names)
  }
  //
  componentWillReceiveProps(nextProps) {
    this.groupSortFundsSetState(nextProps.result)
  }
  groupSortFundsSetState = (f) => {
    const groupedSortedFunds = this.groupSortFunds(f)
    if (groupedSortedFunds) {
      this.setState({fundsByStrategy: groupedSortedFunds})
    }
  }
  //
  groupSortFunds = (f) => {
    const d = {}
    if (
      f &&
      Array.isArray(f) &&
      f.length > 0
    ) {
      for (let i = 0; i < f.length; i++) {
        const currFund = f[i]
        const currStrategy = currFund.strategy_name
        if (!(d[currStrategy] && Array.isArray(d[currStrategy]))) {
          d[currStrategy] = []
        }
        d[currStrategy].push(currFund)
      }
      //
      for (let p = 0; p < Object.keys(d).length; p++) {
        const sortStrategy = Object.keys(d)[p]
        const currFundsList = d[sortStrategy]
        currFundsList.sort((a, b) => a.fund_legal_name.localeCompare(b.fund_legal_name))
        d[sortStrategy] = currFundsList
      }
      return d
    }
    return null
  }

  //
  render() {
    if (!this.props.result) {
      // 
      return <div style={{position: 'relative'}}>
        <Loader
          options={{scale: 0.70, position:'absolute', top:'4.0rem'}}
          loaded={ false }
        />
      </div>
    }

    const { targetDateSeriesList } = this.state

    const gradeField = {
      'Fossil Free Funds': 'grade_fossil',
      'Deforestation Free Funds': 'grade_deforestation',
      'Gender Equality Funds': 'grade_gender_equality',
      'Gun Free Funds': 'grade_guns',
      'Prison Free Funds': 'grade_prison_industrial_complex',
      'Weapon Free Funds': 'grade_military',
      'Tobacco Free Funds': 'grade_tobacco'
    }[config.app.title] || null

    const gradeName = {
      'Fossil Free Funds': 'Fossil fuel',
      'Deforestation Free Funds': 'Deforestation',
      'Gender Equality Funds': 'Gender equality',
      'Gun Free Funds': 'Civilian firearm',
      'Prison Free Funds': 'Prison industrial complex',
      'Weapon Free Funds': 'Military weapon',
      'Tobacco Free Funds': 'Tobacco'
    }[config.app.title] || null

    if (!gradeField) { return null }

    //
    return (
      <div styleName='companies'>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='companies-inner'>
          <div styleName='companies-title'>
            Target date funds
          </div>
          <div styleName='companies-info'>
            Target date funds are groups of funds, where each fund in the
            series targets a different mix of stocks and bonds for investors with
            different retirement time horizons. The default option in
            employer-offered retirement plans is often a target date fund series.
            Below are {config.targetDateSeries.length} of the largest
            target date fund series, rated using the 2050 fund.
          </div>

          <div styleName='companies-boxes'>
            <Row>
              <Col xs={12} sm={11}>
                <div styleName='grade-label'>
                  {gradeName} grade<br/>for 2050 fund
                </div>
              </Col>
              <Col xs={12} sm={1} />
            </Row>
            {
              targetDateSeriesList.map((fund, idx) =>{
                return (
                  <TargetDateGridItem
                    key={'target-date-grid-item-' + idx}
                    fund={fund}
                    gradeField={gradeField}
                    funds={this.state.fundsByStrategy[fund.strategy_name]}
                  />
                )
              })
            }
          </div>

        </div>
      </div>
    )
  }
}
